
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqG49zTqpZg_1aX_ZzzwXdO0H6EfiWoymFrrv9_G_Ewd4Meta } from "/build/pages/faq.vue?macro=true";
import { default as indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta } from "/build/pages/index.vue?macro=true";
import { default as ciastkaVycqczT0LXmX8DKNDOqqHuI1ch6p2KujkEz5M3XzJu0Meta } from "/build/pages/ciastka.vue?macro=true";
import { default as ukrainaofCl_mJi50NDCzX9AlEHG8WwdDEbL24PhWRAICZKWTYMeta } from "/build/pages/ukraina.vue?macro=true";
import { default as about_45usQqeQGTjcBjD9TxMUJrsb0hcxrM3GQ7FdiLxa4Y4_2N4Meta } from "/build/pages/about-us.vue?macro=true";
import { default as floragenH5z6vyjcYXWfFTnc9R3N65A2SLI1wbNTczxvSGLWwbMMeta } from "/build/pages/floragen.vue?macro=true";
import { default as lm_45brusssLyEhXqNrJiF5ApRUUvR_ZTMm_RHhE21cFsFYaDlQKIMeta } from "/build/pages/lm-bruss.vue?macro=true";
import { default as ciazaVfBxkRCEf93U9mS2877BwMXUBgg05nFI5AzwShp_lzgMeta } from "/build/pages/lp/ciaza.vue?macro=true";
import { default as sportEyXN8W5GlTFKd0cjeCwOQf0VdqORIpOnCP0OR0yO3L8Meta } from "/build/pages/lp/sport.vue?macro=true";
import { default as regulamin49lGYayqwA80tS5LIV7DX76ChFk1UHv_45eyX9_45v_MazoMeta } from "/build/pages/regulamin.vue?macro=true";
import { default as alergia9owCjsd0Fkkp7Yrmch95TNyUJOurGnS_454q1sGfsXGY4Meta } from "/build/pages/lp/alergia.vue?macro=true";
import { default as reklamacjeDd8yp69_FSMdLl8kD8f9y7AwqlAJISsY5dxvzShZSacMeta } from "/build/pages/reklamacje.vue?macro=true";
import { default as indexyqCtAmtZsQJQbh3_RFvY00Hbdy2L6YOQC7f5BdXAYcUMeta } from "/build/pages/ciaza/index.vue?macro=true";
import { default as food_45profilMNtoE7Vh8TvSPFk_45p1vzVrqxiT81iJGzMfkvWwcuO5wMeta } from "/build/pages/food-profil.vue?macro=true";
import { default as indexz2U4swiT0c_XMprAg4qEnODdlnQGhEizEXwspTfhsEYMeta } from "/build/pages/kiosk/index.vue?macro=true";
import { default as tarczyca0auBdQEoWtSivJW_45eVEaKJNilFZYlp26nQ9cmE94l9AMeta } from "/build/pages/lp/tarczyca.vue?macro=true";
import { default as index25z7SjlhJ_45OoobNVhHD1OSlUzUGuWoigI372nym4f6EMeta } from "/build/pages/doctor/index.vue?macro=true";
import { default as _91code_93pfCuODb6t0xHUm0vF0NTu8pi4GncTFA7JAATk_45Fn5bsMeta } from "/build/pages/error/[code].vue?macro=true";
import { default as indexr71agIwTphyfqxw_qAyO1DWuBizreIvaxCCvmwBS4ogMeta } from "/build/pages/static/index.vue?macro=true";
import { default as test_45harmonyixex4j4Q9v3ElAEh2kVKv8emnpryl3FY6yeIpr3i4DUMeta } from "/build/pages/test-harmony.vue?macro=true";
import { default as faqgHcK_70qTTc5xkcC7YtRa3nrM9ou_45XjfIldgStunRssMeta } from "/build/pages/testalex/faq.vue?macro=true";
import { default as indexX6EXGW4XPTDXHGeD_KmytLHQvaDwdJxiKR6AOK7MJl8Meta } from "/build/pages/contact/index.vue?macro=true";
import { default as witamina_45dvYy5h8RXPQ89fcFforsznvfVuZLUyPezZSt9NrBscP8Meta } from "/build/pages/lp/witamina-d.vue?macro=true";
import { default as _91slug_93vRfnHCxvRmKw6l7ug1jKnF05pREu18SYwa7ni5i4n_450Meta } from "/build/pages/pakiet/[slug].vue?macro=true";
import { default as _91slug_93e_cOhZtAOz_45_NO61YRMJ0Tyf4GX24uPcTRFbBCxKbeoMeta } from "/build/pages/static/[slug].vue?macro=true";
import { default as _91slug_93BjYVtkKJD3Mao3D3unoVpqr_455_45sMEetxnONbqH6kTToMeta } from "/build/pages/badanie/[slug].vue?macro=true";
import { default as migracja_45kontacyy3Ur7zN_WX0e6F2chpKpiaGHaGZW15vZrU3zV0ItAMeta } from "/build/pages/migracja-konta.vue?macro=true";
import { default as rozowa_45wstazkaAySTBbY7ECI4fesjnXvDzq_SgociK0ncCA4mzhDtqWsMeta } from "/build/pages/rozowa-wstazka.vue?macro=true";
import { default as indexE0fl6vuFSy6DiUNNCWQcp9jwQVn2eyu7uaPtfknrwJUMeta } from "/build/pages/testalex/index.vue?macro=true";
import { default as indexbVXdh_AikixC_as8mxgG1GdHcyIkwQX_45niKfIiP9c4MMeta } from "/build/pages/borelioza/index.vue?macro=true";
import { default as faktura7LG9QwK4PIqLbjXZQGebh0sGXhg_45MnqbjCqpm8vaQqMMeta } from "/build/pages/contact/faktura.vue?macro=true";
import { default as hplc3MAVPdjzpxRzfdCkMuSFwRRFVhd6i9VjXOOhc5uhOXQMeta } from "/build/pages/witamina-d/hplc.vue?macro=true";
import { default as _91slug_931e28AEHI1EXOB9hJTX9gjS7ybMjCFnFUFNNlr64aeO0Meta } from "/build/pages/discounts/[slug].vue?macro=true";
import { default as zdrowy_45brzuchqV7R1neqK7tjk2FxsZUDphaA7sdVWAnM4BKHrH_45vhiAMeta } from "/build/pages/lp/zdrowy-brzuch.vue?macro=true";
import { default as index_MtuCnBYN9vzJtVMP3AjYYHc0cHLzUC8w2egUDrMv68Meta } from "/build/pages/nephrohero/index.vue?macro=true";
import { default as indexI8QkP_454Y0UyS1389w8bckI9A1_45_eVMYl0i4NTFc3bdAMeta } from "/build/pages/rezerwacja/index.vue?macro=true";
import { default as indexwWhwpvypxnOJZDI_457t8JDg4VDO6Fcae1fNFniGWAleYMeta } from "/build/pages/witamina-d/index.vue?macro=true";
import { default as indexKDgvN6kIELqJWswXKH4m2K72aX6Wl6i5itvVWOYlB_0Meta } from "/build/pages/alab-w-domu/index.vue?macro=true";
import { default as plockaakj92wfXfZheVHwi14ZxcgR7ZhGPXZOz48STayA3wEMeta } from "/build/pages/alab-w-domu/plock.vue?macro=true";
import { default as sopotdwklTBFQz_ZkJFTYlXHgfKkFUcy7dXyXnlaQ8ASQTQoMeta } from "/build/pages/alab-w-domu/sopot.vue?macro=true";
import { default as videoYYofYbKCKLTLERv_pTw6dpEXKF9QUbSkny_45zJjgrUPYMeta } from "/build/pages/alab-w-domu/video.vue?macro=true";
import { default as jestem_45mamaO01XTssdr0LkwAdlbLARDQzuj9EikBMhsvQxzZyolWwMeta } from "/build/pages/ciaza/jestem-mama.vue?macro=true";
import { default as index0MmgKqjF9uOpkkuy2HsdH8OOn2nV5PvlaTbKZaUAKqoMeta } from "/build/pages/odstapienia/index.vue?macro=true";
import { default as _91slug_93rdyBKh_45UCv3TncjibKOjDwfM3H2vCHd_s1578TqK9dsMeta } from "/build/pages/rezerwacja/[slug].vue?macro=true";
import { default as dla_45kogo4CLeb_45ZS1_45jWZDlfpFUbfpZpKtHV7_mDaVG2aBDHmm0Meta } from "/build/pages/testalex/dla-kogo.vue?macro=true";
import { default as gdanskkcGYeu4IzvhUJBoMekHhwTIwWTOfAfiuW2D_vzpHDzsMeta } from "/build/pages/alab-w-domu/gdansk.vue?macro=true";
import { default as gdyniad5GIV4g6CSH_PAdixURAL2_45nEHGLqOHScyQk3_oty8sMeta } from "/build/pages/alab-w-domu/gdynia.vue?macro=true";
import { default as krakowi6k_456_45OPmP_ljwQtNfPkH_45D5JuYt2pFc62jLc6bLsmMMeta } from "/build/pages/alab-w-domu/krakow.vue?macro=true";
import { default as poznanr01EtBQmR_pFp2VnflLpNQTh_45w4_45oLm_HlYl09bxsssMeta } from "/build/pages/alab-w-domu/poznan.vue?macro=true";
import { default as wspolpracaU8_VbSfyXvHMirjcIcnHgnfpLY_dlpdEdegp8fuiKK0Meta } from "/build/pages/contact/wspolpraca.vue?macro=true";
import { default as zdrowie_45intymneJSoTm8LGHcrNzEWw4xi21ZmWXfFQPtpdqr8p5aXsBF8Meta } from "/build/pages/lp/zdrowie-intymne.vue?macro=true";
import { default as zdrowie_45kobietyFNYCimng6P1ZoY5fv1XqjToPNrScUnXPWRvXcQKb_45cMMeta } from "/build/pages/lp/zdrowie-kobiety.vue?macro=true";
import { default as pakiety_45dla_45kobietEn0uHF5BoY0v9ODJ9azI4TXsWZbu6_45_45qg0c_45HlucnEoMeta } from "/build/pages/pakiety-dla-kobiet.vue?macro=true";
import { default as rzeszowhm_ihWlIhtJ1m3e6AeVAPQpnavGJUHdhwgWWZTHHVPQMeta } from "/build/pages/alab-w-domu/rzeszow.vue?macro=true";
import { default as wroclawgbAKCPMaKIoZa3daHaoAV8HIRbmUr5nNyDxLqGielEgMeta } from "/build/pages/alab-w-domu/wroclaw.vue?macro=true";
import { default as wiek_45biologicznyxs5SFQYPmRMzHQ0dUrpBiWvxJ342uvCZDe2_MnWbw3cMeta } from "/build/pages/lp/wiek-biologiczny.vue?macro=true";
import { default as index0nzWOUVWwSaGsR2s21T90TlWaDNl_451s2XECqzE7MTxMMeta } from "/build/pages/passwordreset/index.vue?macro=true";
import { default as _91id_936mpzX_UFJMJ4o_45xbRfcTtoTwvxuCpLLo1SAbcAKPSVsMeta } from "/build/pages/preview/pakiet/[id].vue?macro=true";
import { default as indexJRv3Tf3F0m0U_S8YRzuGf6siRKEhNqKeDIgHpY4locsMeta } from "/build/pages/punkty-pobran/index.vue?macro=true";
import { default as dlaczegoRE4BKjAaAXBP4zVL7UOCa6K62hXVvWj7ZiS0afLIWDgMeta } from "/build/pages/witamina-d/dlaczego.vue?macro=true";
import { default as historiaybBGesSBCIznCeg270N_XGI0QfqstHAuDuR1g7zj_452EMeta } from "/build/pages/witamina-d/historia.vue?macro=true";
import { default as niedoborc_kU8H9cWNMWQmrTIlIRG2xhVc3RfM16tdN6g0ql9X0Meta } from "/build/pages/witamina-d/niedobor.vue?macro=true";
import { default as wlasny_45zestaw_45badaniJcY6lpufhrG1GlMWLC5Rg0Y9H3vmxvlBiPVpgqD7coMeta } from "/build/pages/wlasny-zestaw-badan.vue?macro=true";
import { default as katowicecn33QkD4G9GkZRWEZSCA0Ya3_KQGkuuY0iH3MJskYhgMeta } from "/build/pages/alab-w-domu/katowice.vue?macro=true";
import { default as warszawaJnLf3JIGNOt_bMcGgDpwF47c5Cbdnx2a8Z5zXG53u4gMeta } from "/build/pages/alab-w-domu/warszawa.vue?macro=true";
import { default as jestem_45w_45ciazylMK6c1bb_ODWezRjLMkEqef4JNj_45X3eXSKCKew3F9Q4Meta } from "/build/pages/ciaza/jestem-w-ciazy.vue?macro=true";
import { default as indexGeU3UPLDiwNrGrJMxeK0Zo_45dHCojuzaZnV0CUq363CQMeta } from "/build/pages/kiosk/checkout/index.vue?macro=true";
import { default as _91order_id_93twL2FP2Q6hhWJaTNgVB7P8jUmCAZmlJXnW_45iORua8C0Meta } from "/build/pages/kiosk/pay/[order_id].vue?macro=true";
import { default as pakiety_45dla_45mezczyzn3HpWcrzRvJ5g5zbNvXKpMzY3wcaE3eQ7IAYGdl5pBNIMeta } from "/build/pages/pakiety-dla-mezczyzn.vue?macro=true";
import { default as polityka_45prywatnoscibWqoL6cjkdeXaImJdS5U_T6xsXxRuzh3qANtuGmfZYsMeta } from "/build/pages/polityka-prywatnosci.vue?macro=true";
import { default as _91id_93olBe6EMJ7xCdH4tk4MSuiBdg_IgkWd0oESRqbPyAqcAMeta } from "/build/pages/preview/badanie/[id].vue?macro=true";
import { default as profilaktyka_4540_45plusbFdsqcuz90zrM6BUma_452giKYOSODJYIW1nYUYrXTMWQMeta } from "/build/pages/profilaktyka-40-plus.vue?macro=true";
import { default as miastawPsdC6LgaQzYZuS2gtgrdvIs0oTlPQxB_Oo5acF7gDQMeta } from "/build/pages/punkty-pobran/miasta.vue?macro=true";
import { default as privacy_45policyBkdAB1WwopYu_5RlrLvglIDXYGivUXBRIh5yzAuD1FYMeta } from "/build/pages/doctor/privacy-policy.vue?macro=true";
import { default as chce_45byc_45w_45ciazyUuqEikNCEfTvHJrWxhz9_1kTdcaQwVu_AI2AtNvQ5lEMeta } from "/build/pages/ciaza/chce-byc-w-ciazy.vue?macro=true";
import { default as wyszukaje3o9Z3lCydeaJ2y6zEsuV7Ek45Idzt1NoxBb684_Kp4Meta } from "/build/pages/katalog-badan/wyszukaj.vue?macro=true";
import { default as zapis_45na_45newsletterC9YOmKXaSoXmMsfjQkars5Ad8o1Wk8Wk7NJbhPr5ADAMeta } from "/build/pages/lp/zapis-na-newsletter.vue?macro=true";
import { default as obowiazek_45informacyjnyGPiFL1oBH27WnbmqneWtLVjYyOIww_45tSTbIhl99pO_45oMeta } from "/build/pages/obowiazek-informacyjny.vue?macro=true";
import { default as _91id_93elnxm4fbOT1MhMWjpd8c6S_mYqT0RAel60pK1hZLuBIMeta } from "/build/pages/preview/kategoria/[id].vue?macro=true";
import { default as informacje_45dla_45pacjentablX6n_Zb4vj04YT2mwQZvyMjxUyoVlOz2E7NF7fYpuEMeta } from "/build/pages/informacje-dla-pacjenta.vue?macro=true";
import { default as _91slug_930kwI2FJi8Du__wSTMUqBPO8ie2rL9Pz4jlii0U5CpMsMeta } from "/build/pages/badanie/kategorie/[slug].vue?macro=true";
import { default as indexSJN8fa7aXohWCejLVphb1Q_vb1Xf4tJlHWHrojJ7yLYMeta } from "/build/pages/pracownia-genetyki/index.vue?macro=true";
import { default as przygotowanie_45do_45badaniajEhj7Kqa60jyAOv6DAK8q_ZAtw_hwhZyL99jE91kVdUMeta } from "/build/pages/przygotowanie-do-badania.vue?macro=true";
import { default as badane_45alergenyG3GbUZlKLPKxOzBB4bZV9U4u3R0YWsJxePPKYWJF8o0Meta } from "/build/pages/testalex/badane-alergeny.vue?macro=true";
import { default as interpretacjaY9OyviZcwSDQigkFQcAWNCjOyA7AA_4583f8JEgVqJO1IMeta } from "/build/pages/witamina-d/interpretacja.vue?macro=true";
import { default as index3NiHWHkcdhzxYPunWoCs7BXlTsUljTwzcEfo4Q_ByO0Meta } from "/build/pages/diagnostyka-alergii/index.vue?macro=true";
import { default as indexB2hl3YdhfN_45NHhPazSdKElMf_lKFaoEcuMN0GECtjEsMeta } from "/build/pages/diagnostyka-autyzmu/index.vue?macro=true";
import { default as indexBKQlv1YGt1XZpxy01IAMNH6zzSIJnYDiCZULzyKbULwMeta } from "/build/pages/kiosk/service-break/index.vue?macro=true";
import { default as przedawkowaniehvjuQlPQpl8qtYWAXFBTC7L82KrrN6SPM2n6idxs3BUMeta } from "/build/pages/witamina-d/przedawkowanie.vue?macro=true";
import { default as index97gbxgOsL0dFdMt2jDtUBPmDpEjNO7ok6ixd0qnNyesMeta } from "/build/pages/akcje-profilaktyczne/index.vue?macro=true";
import { default as badanie_45kleszczaL8bOovZ8TYpFbuchL2lzn3JQh1rNpsegS_61YCKuY3sMeta } from "/build/pages/borelioza/badanie-kleszcza.vue?macro=true";
import { default as indexpFeT0YGPDJZ2lRQCcVpv_456Ivmg8UUv36YnMestGavQoMeta } from "/build/pages/kiosk/payment/failed/index.vue?macro=true";
import { default as indexfY7bROlVLF7oSX0R7VY4z8WayAzu36BDkadsIbBDVmgMeta } from "/build/pages/nephrohero/zalecenia/index.vue?macro=true";
import { default as indexzAdURIsBb97kSA979GsDSYKJglM852dVkoN972oSR7QMeta } from "/build/pages/passwordreset/[slug]/index.vue?macro=true";
import { default as index3kYe54rXh0deP_454v3ftIgF0OMzvwKTae720T_45r_OMqwMeta } from "/build/pages/punkty-pobran/[city]/index.vue?macro=true";
import { default as _91slug_93a4UAK4CqJLwFLzvQ69PVX_wAq_45Dv8fpnS5MGUBcWH5UMeta } from "/build/pages/akcje-profilaktyczne/[slug].vue?macro=true";
import { default as partner_45terms_45of_45use0uWH7pmN0BrJEv41c2JiQtt7hPhRGB7_6jDMayqPfxAMeta } from "/build/pages/doctor/partner-terms-of-use.vue?macro=true";
import { default as indexpm2yeuT0xDcuHTw9Oy1vPFB9PbPRL300UfKXMkUdzvwMeta } from "/build/pages/interpretacja-wynikow/index.vue?macro=true";
import { default as pakiet_45wlasnyvtQeKMn1cVHd0CNZCTqzZ2MsR_45N6dQWdBkCKE9dnCKgMeta } from "/build/pages/katalog-badan/pakiet-wlasny.vue?macro=true";
import { default as indexaf_45LteO_45SmAPhyEjyUUono9hWrD_yK9kIMa2TKVep8UMeta } from "/build/pages/kiosk/payment/success/index.vue?macro=true";
import { default as indexFTSHSMBb5UVAp_f6QAOhHnjjm6cttXE9PvircT6z98IMeta } from "/build/pages/nephrohero/slowniczek/index.vue?macro=true";
import { default as _91slug_935efGBItKmNs4jI9UT6nuuMkJ5AGyAxiwzk5Xnt7Wr2IMeta } from "/build/pages/punkty-pobran/[city]/[slug].vue?macro=true";
import { default as minus503RPu6GQEGMoxTw2_OnDAwb5NJB_45_iIRDVMFl_45xf7_450IMeta } from "/build/pages/akcje-profilaktyczne/minus50.vue?macro=true";
import { default as sexedplZj_45Rhq5H5gTvjnSIn8hp2osajFl60y9CotGwh0JJA6cMeta } from "/build/pages/akcje-profilaktyczne/sexedpl.vue?macro=true";
import { default as nagalazaLwjiX_451jeuJS3IuIROWbj9zyMzBlEri9VLleISXjEuwMeta } from "/build/pages/diagnostyka-autyzmu/nagalaza.vue?macro=true";
import { default as indexjDQAA0uVI2G5su_459EhNlLswIDpSg211vUkHfNAwToOYMeta } from "/build/pages/diagnostyka-genetyczna/index.vue?macro=true";
import { default as odbioraCWrj0AQ3lB_bEkl9yn8lPsAGtOTVfewEV9CwcHFdN4Meta } from "/build/pages/interpretacja-wynikow/odbior.vue?macro=true";
import { default as indexWQWiclLeiD4mkQ_45eUEUSCgPDFn_45hlzDqhIshr_45S_453r0Meta } from "/build/pages/kiosk/appointment-form/index.vue?macro=true";
import { default as wyszukajAQQ_45chiKu_45i1kRRfMsqzDVcTy6V1KXuU4qt3pDGjxQIMeta } from "/build/pages/kiosk/katalog-badan/wyszukaj.vue?macro=true";
import { default as index66DU_45iWf1_javWCLtC_45RGvjZTC0bwy1N2rrFZlfJFWcMeta } from "/build/pages/kiosk/payment/rejected/index.vue?macro=true";
import { default as jak_45i_45gdzie_45wykonacuTCK2ZbTG6HdTxNQAQ0DIR8YCYzArXc6RhiCYKdlh_oMeta } from "/build/pages/testalex/jak-i-gdzie-wykonac.vue?macro=true";
import { default as _100badanFsc6Mn1fm43gJJ1yGqZHBOb5U2U1K54aoAdKUfG7W2UMeta } from "/build/pages/akcje-profilaktyczne/100badan.vue?macro=true";
import { default as movembervXwAyQju_H31QpDOxXIKAFq6q_454MGHdf701RujNCxgQMeta } from "/build/pages/akcje-profilaktyczne/movember.vue?macro=true";
import { default as sezonowaU8oNt6XyD5nUEXiVsuaYPfWw4lXrubDY7RGICtfO25sMeta } from "/build/pages/akcje-profilaktyczne/sezonowa.vue?macro=true";
import { default as diagnostyka_45wstepnaHWI9kXyVK8G6xmFO13o4QYae9NqCuPw8sZKuq8L_GroMeta } from "/build/pages/borelioza/diagnostyka-wstepna.vue?macro=true";
import { default as testy_45potwierdzeniaLfgpVL2IF3p0r8zo6l6qLzzClszjvc_vEZY8xWIKKH4Meta } from "/build/pages/borelioza/testy-potwierdzenia.vue?macro=true";
import { default as pary5CuBZsAqbmjTaBcYuNpd_gTdPH_PwZfbYw5ZfOrtIl0Meta } from "/build/pages/diagnostyka-nieplodnosci/pary.vue?macro=true";
import { default as blackweek7iQZUgNpZ4TK_LacdNWBeg0iTrS7CCOsXgQzz7Wxr4wMeta } from "/build/pages/akcje-profilaktyczne/blackweek.vue?macro=true";
import { default as kwartalnaVk2Te7ovYcyztgFeXhg8OBZnpdVxB4IGYpdq1NS1m88Meta } from "/build/pages/akcje-profilaktyczne/kwartalna.vue?macro=true";
import { default as indexNGgSB_9l1t5HIQ_4585RPsJuSe8JdyITv3P_Ef1wpxugsMeta } from "/build/pages/badania-mikrobiologiczne/index.vue?macro=true";
import { default as informacje_45o_45badaniachmgSgOtjQUXVj26UmZ5w_DhToJkfDOiTupulibSF6fOYMeta } from "/build/pages/contact/informacje-o-badaniach.vue?macro=true";
import { default as genetycznaR7fYY3Ed62cmLu_V8gHvgT_HoyCnIFA5uogfzKGL0mgMeta } from "/build/pages/diagnostyka-autyzmu/genetyczna.vue?macro=true";
import { default as podstawoweHilwLgKT9po66hBwSlMWvz_8ssfizxNa7wmidfGVkWYMeta } from "/build/pages/diagnostyka-autyzmu/podstawowe.vue?macro=true";
import { default as indexaCOlKorTSxYakMcu2fqd3eHig8eCJLL8_454FgeHV0j7gMeta } from "/build/pages/diagnostyka-nieplodnosci/index.vue?macro=true";
import { default as kobietXH41TfkzYelRVppM4Eo5PAoUBpJiEiQIUCYwu_KtXjUMeta } from "/build/pages/diagnostyka-nieplodnosci/kobiet.vue?macro=true";
import { default as biochemicznaouyAXHqAgtEgGVgi5JQOPHf9eLqaMQ3GoKEFoHhMZpAMeta } from "/build/pages/diagnostyka-autyzmu/biochemiczna.vue?macro=true";
import { default as endotoksemiaaisajrCQMf8DlHZzNeFIOSsuA3AgYstuka0h1YDrSrcMeta } from "/build/pages/diagnostyka-autyzmu/endotoksemia.vue?macro=true";
import { default as przykladowe_45konsultacjejUYhZexbKTntP72LW1bhLgjpnXskaHGezzFWmDKzwgQMeta } from "/build/pages/testalex/przykladowe-konsultacje.vue?macro=true";
import { default as minus_45koszyki1hhwQ5Qs1EgRklSAYDTscGVfrWiHaveIyWaTxwyw5wMeta } from "/build/pages/akcje-profilaktyczne/minus-koszyk.vue?macro=true";
import { default as gruzlicaPzzviHhPTvMOqJJereZykO_45Pk0ev_PY6st0G2H7KGQoMeta } from "/build/pages/badania-mikrobiologiczne/gruzlica.vue?macro=true";
import { default as mezczyznBqr4XD0DezXY_lMsPMUNIy3CaWSU_rp_45xDsbMRhG8CwMeta } from "/build/pages/diagnostyka-nieplodnosci/mezczyzn.vue?macro=true";
import { default as indexx5Pq_Gd8NdFbKVEQLTbZgsMLHLRd2XFg5NkwYlUlCMsMeta } from "/build/pages/kiosk/payment/no-connection/index.vue?macro=true";
import { default as index5Rcn8WV1walPbVaPZ2mMhumlUukSpGWQZbIk3sVZHswMeta } from "/build/pages/pojedyncze-testy-alergenowe/index.vue?macro=true";
import { default as punkty_45pobrangOCAH_45PkqKuVvIACfeypUiYKPT7K_45kQ4VCArVvGuHc0Meta } from "/build/pages/akcje-profilaktyczne/punkty-pobran.vue?macro=true";
import { default as suplementacjaji_45y7hQ_45tAV5oHZFmjKHYkTpZJG7gL5TS1cD2L_s8xsMeta } from "/build/pages/akcje-profilaktyczne/suplementacja.vue?macro=true";
import { default as uzupelnienie_45diagnostykim5ZgWMc6ljqyfFRKhC2XsyUgHURmQnTY_vKVmCHK_45OYMeta } from "/build/pages/borelioza/uzupelnienie-diagnostyki.vue?macro=true";
import { default as panele_45atopoweMlq5vYXCZj3GuyqX8eWE7Qq8_45suSTwCp6wdEvB0zYMIMeta } from "/build/pages/diagnostyka-alergii/panele-atopowe.vue?macro=true";
import { default as panele_45wziewner4XK885LM0YtoTN56l3D4OQIWJ0beuWOYykzyvW9ObsMeta } from "/build/pages/diagnostyka-alergii/panele-wziewne.vue?macro=true";
import { default as markery_45stresusuijHKwyhq7ad1BA7iKaBzgJ9BbMXqKOM9HuSj6fAEkMeta } from "/build/pages/diagnostyka-autyzmu/markery-stresu.vue?macro=true";
import { default as _91step_93yHDYGkL1MjJ9vrnR34cktYwtX3u4T0PwiVlUiiO_4yQMeta } from "/build/pages/interpretacja-wynikow/[slug]/[step].vue?macro=true";
import { default as miesiac_45rodzinyS00TKWuFUkDDZTkuCG06b08rVwO_9e_458JPRf7hWD3ScMeta } from "/build/pages/akcje-profilaktyczne/miesiac-rodziny.vue?macro=true";
import { default as panele_45pokarmowep56r_c_1x6C6X_A_45pAfBLcZY58vTdqqmMGDkWT4qKrMMeta } from "/build/pages/diagnostyka-alergii/panele-pokarmowe.vue?macro=true";
import { default as indexEanhnN2qJW2Se9VxpYCG9yY8Qe_45WHkbrbrY9uykx4yAMeta } from "/build/pages/kiosk/appointment-confirmation/index.vue?macro=true";
import { default as panel_45molekularnyQKzByMA37sSef4aCgHApgxbHAU4AfRFtFCSgXL9p_lQMeta } from "/build/pages/diagnostyka-alergii/panel-molekularny.vue?macro=true";
import { default as testy_45mix3s4CXME_4TutDpSWTa5UfUjTo4DdLWeJqw_VzQHGP8YMeta } from "/build/pages/pojedyncze-testy-alergenowe/testy-mix.vue?macro=true";
import { default as genetyka_45czlowieka77UvWaIEtG_45As2Pi_EJbl98ttr1YnlYrwqkCApaLm3AMeta } from "/build/pages/pracownia-genetyki/genetyka-czlowieka.vue?macro=true";
import { default as panele_45molekularnezG29AqKAUCbtflK0tYoFt1I1xn9CHrMuyY2I8x4SgrYMeta } from "/build/pages/diagnostyka-alergii/panele-molekularne.vue?macro=true";
import { default as poradnia_45genetyczna4KDrIJoKyuxF7uajAznuT1fa_OT40e_TzgxtX0L20Y0Meta } from "/build/pages/pracownia-genetyki/poradnia-genetyczna.vue?macro=true";
import { default as nowe_45pakiety_45badanDr_zf6MTJjyCl4wdey6c5Th0JmjiMpAha7VfyJVmUBYMeta } from "/build/pages/akcje-profilaktyczne/nowe-pakiety-badan.vue?macro=true";
import { default as dataVot2uwo_d1DxdUGNKqCFDN51ke59qoT25_451e3XsIvM8Meta } from "/build/pages/akcje-profilaktyczne/rozowa-wstazka/data.js?macro=true";
import { default as panele_45pediatrycznesWpafWqvZNQUuB1Za4onizrFigTeJ5A1uhHuaSRoK4AMeta } from "/build/pages/diagnostyka-alergii/panele-pediatryczne.vue?macro=true";
import { default as zaburzen_45jelitowychpmevwjBfdPn5cUvbvQhyWpgXy5Ju7AIRiqBJRalCyIMMeta } from "/build/pages/diagnostyka-autyzmu/zaburzen-jelitowych.vue?macro=true";
import { default as _91_91category_slug_93_93frM6PoqAmUq6lie7xdTLCya4Oywk6wpNp_45cYQBWPH14Meta } from "/build/pages/katalog-badan/badania/[[category_slug]].vue?macro=true";
import { default as _91_91category_slug_93_93aTe0wtv0SkKNnKZ_45Q_45Edak6bGEM9wIM9xLP9VqDRx68Meta } from "/build/pages/katalog-badan/pakiety/[[category_slug]].vue?macro=true";
import { default as brca1Js033HayRUsfip5Ct_457Er_D1Kj8EIQMGCIskX3bhkCwMeta } from "/build/pages/akcje-profilaktyczne/rozowa-wstazka/brca1.vue?macro=true";
import { default as brca2lbOahLXtNOE37qgtjp15PuvWZPNwk2izXV_45jsatnI_AMeta } from "/build/pages/akcje-profilaktyczne/rozowa-wstazka/brca2.vue?macro=true";
import { default as index33VY1mFEi0rBukDLbAChCDVmSzAj8cenerZq3m2eld8Meta } from "/build/pages/akcje-profilaktyczne/rozowa-wstazka/index.vue?macro=true";
import { default as biocenoza_45pochwyFpD_45Rq67FMMozAddOqZIBTDbJhZlJkeWlc6hZuxxnIYMeta } from "/build/pages/badania-mikrobiologiczne/biocenoza-pochwy.vue?macro=true";
import { default as methodsFQ9lJkbXny2XOxeNVXy5tTvvWfkBwT9topqEeq5p9D4Meta } from "/build/pages/diagnostyka-genetyczna/components/methods.vue?macro=true";
import { default as dzien_45babci_45i_45dziadkanl5PVVZGr2Ax24YjHe4L96a_iJGX_45AWM2bhvK0xQo5YMeta } from "/build/pages/akcje-profilaktyczne/dzien-babci-i-dziadka.vue?macro=true";
import { default as po_45drodze_45ze_45zdrowiemuOe69mkHG35ZNuKCzuICGQIT_DgjRmv_45LCH5ZkWQGrEMeta } from "/build/pages/akcje-profilaktyczne/po-drodze-ze-zdrowiem.vue?macro=true";
import { default as jady_45leki_45inneszPNukGzm2xq__45tz7VzVPhzKzD_Q2rrr50ojDz7rA78Meta } from "/build/pages/pojedyncze-testy-alergenowe/jady-leki-inne.vue?macro=true";
import { default as zakazenia_45pokarmoweWL9_45vg0zECslL1DC4y0IIzJXnsF8oqJ8RyydRBW_45bhwMeta } from "/build/pages/badania-mikrobiologiczne/zakazenia-pokarmowe.vue?macro=true";
import { default as aktywnosc_45immunologicznaPPPBgJkMRuntjJeASYvP5g9Ngnfb_45Y5w_WU0rULEZPkMeta } from "/build/pages/diagnostyka-autyzmu/aktywnosc-immunologiczna.vue?macro=true";
import { default as mikroelementy_45i_45witaminyI0AWNlGs7anQIxzB0WF1sqogwkOY8EJdwtdggvGBIbsMeta } from "/build/pages/diagnostyka-autyzmu/mikroelementy-i-witaminy.vue?macro=true";
import { default as alergeny_45wziewneGnUH2Jb7M41pDhm_RWb6c3KwHUGlZVDMxbDugOFpJtIMeta } from "/build/pages/pojedyncze-testy-alergenowe/alergeny-wziewne.vue?macro=true";
import { default as cytologiacgjmHJ1q1IN1SdXtnrI0mmccIqmdUKgjXgF5qwYRsp0Meta } from "/build/pages/akcje-profilaktyczne/rozowa-wstazka/cytologia.vue?macro=true";
import { default as _91_91category_slug_93_93PfDh3CPfq2PWfRotpqHGj1daVBX4KkFGDf0dOp0nkXAMeta } from "/build/pages/kiosk/katalog-badan/badania/[[category_slug]].vue?macro=true";
import { default as _91_91category_slug_93_933OhST4Ulnkq_450MS_45wr1st_JFbjT_45gfLaSXhxs8fvpIkMeta } from "/build/pages/kiosk/katalog-badan/pakiety/[[category_slug]].vue?macro=true";
import { default as pakiety_45alergenowY2pCjHJQYlQll71QWfl3hSMtv_45_Uvsslt2_P93u2NN0Meta } from "/build/pages/pojedyncze-testy-alergenowe/pakiety-alergenow.vue?macro=true";
import { default as consultationAI0Wjh4G_1M9f2IH02APiHeSqxSbpZ1_IhYOe5hzJ9gMeta } from "/build/pages/diagnostyka-genetyczna/components/consultation.vue?macro=true";
import { default as indexJyn4oEFNN3S1XBJqvETyNYPthBT0Q05uEWlbCebZLrgMeta } from "/build/pages/nephrohero/przewlekla-choroba-nerek-pchn/index.vue?macro=true";
import { default as alergeny_45pokarmoweMwrRAOIBYb_453ABu6WNs1JQzycuDrYc_u6IrVYPSmqxkMeta } from "/build/pages/pojedyncze-testy-alergenowe/alergeny-pokarmowe.vue?macro=true";
import { default as index1tQFpEXpFJOJgjdu6XHAnBToLAjSC_45wEz1cnCPq3F2MMeta } from "/build/pages/nephrohero/diagnostyka-laboratoryjna-pchn/index.vue?macro=true";
import { default as molekuly_45alergenowewIdr7kb7v_A4cR1upygc463fffKHhU2bldpaM1AoZKMMeta } from "/build/pages/pojedyncze-testy-alergenowe/molekuly-alergenowe.vue?macro=true";
import { default as ojcostwo_45testy_45pokrewienstwartHO4_45_45v2BNqy8frW6grEvD7RfihiOyc6aHjxUcEhXAMeta } from "/build/pages/diagnostyka-genetyczna/ojcostwo-testy-pokrewienstwa.vue?macro=true";
import { default as onkologia_45testy_45predyspozycjiR9VnFgsmB5uUazrXrP1Nyygc2N57_45QR_bsRnYmdjRHgMeta } from "/build/pages/diagnostyka-genetyczna/onkologia-testy-predyspozycji.vue?macro=true";
import { default as zaburzenia_45gospodarki_45lipidowejTdO4GCtoIq4MpLHolDQu0fzCkOeqnIDDqH_KqAiuC0YMeta } from "/build/pages/diagnostyka-genetyczna/zaburzenia-gospodarki-lipidowej.vue?macro=true";
import { default as nieinwazyjna_45diagnostyka_45prenatalnaziAGaaIBvDldmoVGx3JKXxxyjGzDK3vq9_JnzhX2MKwMeta } from "/build/pages/pracownia-genetyki/nieinwazyjna-diagnostyka-prenatalna.vue?macro=true";
import { default as farmakogenetyka_45opornosc_45na_45lekioZgxPCPFCN8eb02qSpAhLSIyoabCEjp2zUjafGZqFcAMeta } from "/build/pages/diagnostyka-genetyczna/farmakogenetyka-opornosc-na-leki.vue?macro=true";
import { default as badania_45w_45kierunku_45dermatofitowmRHVS5Tvo817QCkUZV3RFL5Bd10wkImRa9GF8Wq2GscMeta } from "/build/pages/badania-mikrobiologiczne/badania-w-kierunku-dermatofitow.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45pediatriiAL2aT3Pyp1AqY6WV3IoBLaB1k3_UG8ADOIT0IXT2qaIMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-pediatrii.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45nefrologiir5PJngKn6KV6iHlaanwSoUclZJvfqmu38EsLKbx2iY4Meta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-nefrologii.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45neurologii_eJqLY8VEqnQrPkqhlGOlRU_igtzqGk5_45RzIvMQ2bq4Meta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-neurologii.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45kardiologiiawvZlNRlgTiNHciia5v2GRQHnNl7_45R0CjWDXHa5EQgUMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-kardiologii.vue?macro=true";
import { default as identyfikacja_45genetyczna_45mikroorganizmowR6rH5TApJdgsMmoIKDX_45u8BfLuvtkZTyyIR4WFi_R6cMeta } from "/build/pages/pracownia-genetyki/identyfikacja-genetyczna-mikroorganizmow.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45dermatologiiC8Bivui3_BQUbrWYCczdNhf_rGEkjoJ3dkIqOs9PLc4Meta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-dermatologii.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45pulmonologiiTROUFZrBlk_45iaUvfWZGi2Wo5ylVlCfb163vmGQ2xRa0Meta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-pulmonologii.vue?macro=true";
import { default as onkologia_45diagnostyka_45terapia_45celowanaTk9QGY0lIz0AqJkcNBATViNeIaEVTefngDF5RE5_45mr8Meta } from "/build/pages/diagnostyka-genetyczna/onkologia-diagnostyka-terapia-celowana.vue?macro=true";
import { default as badanie_45w_45kierunku_45nuzycy_45dermodekozyqiuEwvVGbmVV_45eOuM2AeVM9dhhiagUNLK7cG3wXrvyQMeta } from "/build/pages/badania-mikrobiologiczne/badanie-w-kierunku-nuzycy-dermodekozy.vue?macro=true";
import { default as identyfikacja_45drobnoustrojow_45maldi_45tof_45msIn51ITmXU7HxZHW5Dx7Ar8A4JMsDYa49i_5FmH7Ser8Meta } from "/build/pages/badania-mikrobiologiczne/identyfikacja-drobnoustrojow-maldi-tof-ms.vue?macro=true";
import { default as badania_45panelowe_45badanie_45wes_45choroby_45rzadkiehE1i1We4vsE1K5N9Y3Zrsf1_45z8_qV8E86LZ0bJXHTUUMeta } from "/build/pages/diagnostyka-genetyczna/badania-panelowe-badanie-wes-choroby-rzadkie.vue?macro=true";
import { default as diagnostyka_45genetyczna_45zespolow_45dysmorficznych6nxbu2Ye8a2j9Na4jOtc6yUhkuklYU5zgGJi6R8m_456YMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-zespolow-dysmorficznych.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45immunologii_45i_45hematologiiJZJlCNxc0uLYrR3DspXtl2vhcurBH5X0NzvkNCdpdzsMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-immunologii-i-hematologii.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45okulistyce_45i_45otolaryngologiind2_a17yd_45XG_455_wtN970MdkfoWviY8Vz9f9b6h1IAgMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-okulistyce-i-otolaryngologii.vue?macro=true";
import { default as zaburzenia_45gospodarki_45weglowodanowej_45genetyka_45cukrzycyuI6GjI2BEsLGUb0zExQ6VXZwuRBoy4U1619575mAbM4Meta } from "/build/pages/diagnostyka-genetyczna/zaburzenia-gospodarki-weglowodanowej-genetyka-cukrzycy.vue?macro=true";
import { default as diagnostyka_45genetyczna_45nieplodnosci_45planowanie_45ciazy_45badania_45prenatalne0YzkXTP_d_Nz1q1gi3ekNGtJ7vLdP7O6Hqu09DvI9hgMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-nieplodnosci-planowanie-ciazy-badania-prenatalne.vue?macro=true";
import { default as diagnostyka_45genetyczna_45w_45gastroenterologii_45endokrynologii_45i_45chorobach_45metabolicznychsREO16TpxhR6MRIEr160Hcl2WW7WLwPv2KRf1eZbpiQMeta } from "/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-gastroenterologii-endokrynologii-i-chorobach-metabolicznych.vue?macro=true";
export default [
  {
    name: "faq___pl",
    path: "/faq",
    component: () => import("/build/pages/faq.vue")
  },
  {
    name: "index___pl",
    path: "/",
    meta: indexfaSkdcsHLeb812gzXZAgK_hEZEnndCv3Vs4JNO6v_aQMeta || {},
    component: () => import("/build/pages/index.vue")
  },
  {
    name: "ciastka___pl",
    path: "/ciastka",
    component: () => import("/build/pages/ciastka.vue")
  },
  {
    name: "ukraina___pl",
    path: "/ukraina",
    component: () => import("/build/pages/ukraina.vue")
  },
  {
    name: "about-us___pl",
    path: "/about-us",
    component: () => import("/build/pages/about-us.vue")
  },
  {
    name: "floragen___pl",
    path: "/floragen",
    component: () => import("/build/pages/floragen.vue")
  },
  {
    name: "lm-bruss___pl",
    path: "/lm-bruss",
    component: () => import("/build/pages/lm-bruss.vue")
  },
  {
    name: "lp-ciaza___pl",
    path: "/lp/ciaza",
    component: () => import("/build/pages/lp/ciaza.vue")
  },
  {
    name: "lp-sport___pl",
    path: "/lp/sport",
    component: () => import("/build/pages/lp/sport.vue")
  },
  {
    name: "regulamin___pl",
    path: "/regulamin",
    component: () => import("/build/pages/regulamin.vue")
  },
  {
    name: "lp-alergia___pl",
    path: "/lp/alergia",
    component: () => import("/build/pages/lp/alergia.vue")
  },
  {
    name: "reklamacje___pl",
    path: "/reklamacje",
    component: () => import("/build/pages/reklamacje.vue")
  },
  {
    name: "ciaza___pl",
    path: "/ciaza",
    component: () => import("/build/pages/ciaza/index.vue")
  },
  {
    name: "food-profil___pl",
    path: "/food-profil",
    component: () => import("/build/pages/food-profil.vue")
  },
  {
    name: "kiosk___pl",
    path: "/kiosk",
    meta: indexz2U4swiT0c_XMprAg4qEnODdlnQGhEizEXwspTfhsEYMeta || {},
    component: () => import("/build/pages/kiosk/index.vue")
  },
  {
    name: "lp-tarczyca___pl",
    path: "/lp/tarczyca",
    component: () => import("/build/pages/lp/tarczyca.vue")
  },
  {
    name: "doctor___pl",
    path: "/doctor",
    meta: index25z7SjlhJ_45OoobNVhHD1OSlUzUGuWoigI372nym4f6EMeta || {},
    component: () => import("/build/pages/doctor/index.vue")
  },
  {
    name: "error-code___pl",
    path: "/error/:code()",
    component: () => import("/build/pages/error/[code].vue")
  },
  {
    name: "static___pl",
    path: "/static",
    component: () => import("/build/pages/static/index.vue")
  },
  {
    name: "test-harmony___pl",
    path: "/test-harmony",
    component: () => import("/build/pages/test-harmony.vue")
  },
  {
    name: "testalex-faq___pl",
    path: "/testalex/faq",
    component: () => import("/build/pages/testalex/faq.vue")
  },
  {
    name: "contact___pl",
    path: "/contact",
    component: () => import("/build/pages/contact/index.vue")
  },
  {
    name: "lp-witamina-d___pl",
    path: "/lp/witamina-d",
    component: () => import("/build/pages/lp/witamina-d.vue")
  },
  {
    name: "pakiet-slug___pl",
    path: "/pakiet/:slug()",
    component: () => import("/build/pages/pakiet/[slug].vue")
  },
  {
    name: "static-slug___pl",
    path: "/static/:slug()",
    component: () => import("/build/pages/static/[slug].vue")
  },
  {
    name: "badanie-slug___pl",
    path: "/badanie/:slug()",
    component: () => import("/build/pages/badanie/[slug].vue")
  },
  {
    name: "migracja-konta___pl",
    path: "/migracja-konta",
    component: () => import("/build/pages/migracja-konta.vue")
  },
  {
    name: "rozowa-wstazka___pl",
    path: "/rozowa-wstazka",
    component: () => import("/build/pages/rozowa-wstazka.vue")
  },
  {
    name: "testalex___pl",
    path: "/testalex",
    component: () => import("/build/pages/testalex/index.vue")
  },
  {
    name: "borelioza___pl",
    path: "/borelioza",
    component: () => import("/build/pages/borelioza/index.vue")
  },
  {
    name: "contact-faktura___pl",
    path: "/contact/faktura",
    component: () => import("/build/pages/contact/faktura.vue")
  },
  {
    name: "witamina-d-hplc___pl",
    path: "/witamina-d/hplc",
    component: () => import("/build/pages/witamina-d/hplc.vue")
  },
  {
    name: "discounts-slug___pl",
    path: "/discounts/:slug()",
    component: () => import("/build/pages/discounts/[slug].vue")
  },
  {
    name: "lp-zdrowy-brzuch___pl",
    path: "/lp/zdrowy-brzuch",
    component: () => import("/build/pages/lp/zdrowy-brzuch.vue")
  },
  {
    name: "nephrohero___pl",
    path: "/nephrohero",
    meta: index_MtuCnBYN9vzJtVMP3AjYYHc0cHLzUC8w2egUDrMv68Meta || {},
    component: () => import("/build/pages/nephrohero/index.vue")
  },
  {
    name: "rezerwacja___pl",
    path: "/rezerwacja",
    component: () => import("/build/pages/rezerwacja/index.vue")
  },
  {
    name: "witamina-d___pl",
    path: "/witamina-d",
    component: () => import("/build/pages/witamina-d/index.vue")
  },
  {
    name: "alab-w-domu___pl",
    path: "/alab-w-domu",
    component: () => import("/build/pages/alab-w-domu/index.vue")
  },
  {
    name: "alab-w-domu-plock___pl",
    path: "/alab-w-domu/plock",
    component: () => import("/build/pages/alab-w-domu/plock.vue")
  },
  {
    name: "alab-w-domu-sopot___pl",
    path: "/alab-w-domu/sopot",
    component: () => import("/build/pages/alab-w-domu/sopot.vue")
  },
  {
    name: "alab-w-domu-video___pl",
    path: "/alab-w-domu/video",
    component: () => import("/build/pages/alab-w-domu/video.vue")
  },
  {
    name: "ciaza-jestem-mama___pl",
    path: "/ciaza/jestem-mama",
    component: () => import("/build/pages/ciaza/jestem-mama.vue")
  },
  {
    name: "odstapienia___pl",
    path: "/odstapienia",
    component: () => import("/build/pages/odstapienia/index.vue")
  },
  {
    name: "rezerwacja-slug___pl",
    path: "/rezerwacja/:slug()",
    component: () => import("/build/pages/rezerwacja/[slug].vue")
  },
  {
    name: "testalex-dla-kogo___pl",
    path: "/testalex/dla-kogo",
    component: () => import("/build/pages/testalex/dla-kogo.vue")
  },
  {
    name: "alab-w-domu-gdansk___pl",
    path: "/alab-w-domu/gdansk",
    component: () => import("/build/pages/alab-w-domu/gdansk.vue")
  },
  {
    name: "alab-w-domu-gdynia___pl",
    path: "/alab-w-domu/gdynia",
    component: () => import("/build/pages/alab-w-domu/gdynia.vue")
  },
  {
    name: "alab-w-domu-krakow___pl",
    path: "/alab-w-domu/krakow",
    component: () => import("/build/pages/alab-w-domu/krakow.vue")
  },
  {
    name: "alab-w-domu-poznan___pl",
    path: "/alab-w-domu/poznan",
    component: () => import("/build/pages/alab-w-domu/poznan.vue")
  },
  {
    name: "contact-wspolpraca___pl",
    path: "/contact/wspolpraca",
    component: () => import("/build/pages/contact/wspolpraca.vue")
  },
  {
    name: "lp-zdrowie-intymne___pl",
    path: "/lp/zdrowie-intymne",
    component: () => import("/build/pages/lp/zdrowie-intymne.vue")
  },
  {
    name: "lp-zdrowie-kobiety___pl",
    path: "/lp/zdrowie-kobiety",
    component: () => import("/build/pages/lp/zdrowie-kobiety.vue")
  },
  {
    name: "pakiety-dla-kobiet___pl",
    path: "/pakiety-dla-kobiet",
    component: () => import("/build/pages/pakiety-dla-kobiet.vue")
  },
  {
    name: "alab-w-domu-rzeszow___pl",
    path: "/alab-w-domu/rzeszow",
    component: () => import("/build/pages/alab-w-domu/rzeszow.vue")
  },
  {
    name: "alab-w-domu-wroclaw___pl",
    path: "/alab-w-domu/wroclaw",
    component: () => import("/build/pages/alab-w-domu/wroclaw.vue")
  },
  {
    name: "lp-wiek-biologiczny___pl",
    path: "/lp/wiek-biologiczny",
    component: () => import("/build/pages/lp/wiek-biologiczny.vue")
  },
  {
    name: "passwordreset___pl",
    path: "/passwordreset",
    component: () => import("/build/pages/passwordreset/index.vue")
  },
  {
    name: "preview-pakiet-id___pl",
    path: "/preview/pakiet/:id()",
    component: () => import("/build/pages/preview/pakiet/[id].vue")
  },
  {
    name: "punkty-pobran___pl",
    path: "/punkty-pobran",
    component: () => import("/build/pages/punkty-pobran/index.vue")
  },
  {
    name: "witamina-d-dlaczego___pl",
    path: "/witamina-d/dlaczego",
    component: () => import("/build/pages/witamina-d/dlaczego.vue")
  },
  {
    name: "witamina-d-historia___pl",
    path: "/witamina-d/historia",
    component: () => import("/build/pages/witamina-d/historia.vue")
  },
  {
    name: "witamina-d-niedobor___pl",
    path: "/witamina-d/niedobor",
    component: () => import("/build/pages/witamina-d/niedobor.vue")
  },
  {
    name: "wlasny-zestaw-badan___pl",
    path: "/wlasny-zestaw-badan",
    component: () => import("/build/pages/wlasny-zestaw-badan.vue")
  },
  {
    name: "alab-w-domu-katowice___pl",
    path: "/alab-w-domu/katowice",
    component: () => import("/build/pages/alab-w-domu/katowice.vue")
  },
  {
    name: "alab-w-domu-warszawa___pl",
    path: "/alab-w-domu/warszawa",
    component: () => import("/build/pages/alab-w-domu/warszawa.vue")
  },
  {
    name: "ciaza-jestem-w-ciazy___pl",
    path: "/ciaza/jestem-w-ciazy",
    component: () => import("/build/pages/ciaza/jestem-w-ciazy.vue")
  },
  {
    name: "kiosk-checkout___pl",
    path: "/kiosk/checkout",
    meta: indexGeU3UPLDiwNrGrJMxeK0Zo_45dHCojuzaZnV0CUq363CQMeta || {},
    component: () => import("/build/pages/kiosk/checkout/index.vue")
  },
  {
    name: "kiosk-pay-order_id___pl",
    path: "/kiosk/pay/:order_id()",
    meta: _91order_id_93twL2FP2Q6hhWJaTNgVB7P8jUmCAZmlJXnW_45iORua8C0Meta || {},
    component: () => import("/build/pages/kiosk/pay/[order_id].vue")
  },
  {
    name: "pakiety-dla-mezczyzn___pl",
    path: "/pakiety-dla-mezczyzn",
    component: () => import("/build/pages/pakiety-dla-mezczyzn.vue")
  },
  {
    name: "polityka-prywatnosci___pl",
    path: "/polityka-prywatnosci",
    component: () => import("/build/pages/polityka-prywatnosci.vue")
  },
  {
    name: "preview-badanie-id___pl",
    path: "/preview/badanie/:id()",
    component: () => import("/build/pages/preview/badanie/[id].vue")
  },
  {
    name: "profilaktyka-40-plus___pl",
    path: "/profilaktyka-40-plus",
    component: () => import("/build/pages/profilaktyka-40-plus.vue")
  },
  {
    name: "punkty-pobran-miasta___pl",
    path: "/punkty-pobran/miasta",
    component: () => import("/build/pages/punkty-pobran/miasta.vue")
  },
  {
    name: "doctor-privacy-policy___pl",
    path: "/doctor/privacy-policy",
    meta: privacy_45policyBkdAB1WwopYu_5RlrLvglIDXYGivUXBRIh5yzAuD1FYMeta || {},
    component: () => import("/build/pages/doctor/privacy-policy.vue")
  },
  {
    name: "ciaza-chce-byc-w-ciazy___pl",
    path: "/ciaza/chce-byc-w-ciazy",
    component: () => import("/build/pages/ciaza/chce-byc-w-ciazy.vue")
  },
  {
    name: "katalog-badan-wyszukaj___pl",
    path: "/katalog-badan/wyszukaj",
    component: () => import("/build/pages/katalog-badan/wyszukaj.vue")
  },
  {
    name: "lp-zapis-na-newsletter___pl",
    path: "/lp/zapis-na-newsletter",
    component: () => import("/build/pages/lp/zapis-na-newsletter.vue")
  },
  {
    name: "obowiazek-informacyjny___pl",
    path: "/obowiazek-informacyjny",
    component: () => import("/build/pages/obowiazek-informacyjny.vue")
  },
  {
    name: "preview-kategoria-id___pl",
    path: "/preview/kategoria/:id()",
    component: () => import("/build/pages/preview/kategoria/[id].vue")
  },
  {
    name: "informacje-dla-pacjenta___pl",
    path: "/informacje-dla-pacjenta",
    component: () => import("/build/pages/informacje-dla-pacjenta.vue")
  },
  {
    name: "badanie-kategorie-slug___pl",
    path: "/badanie/kategorie/:slug()",
    component: () => import("/build/pages/badanie/kategorie/[slug].vue")
  },
  {
    name: "pracownia-genetyki___pl",
    path: "/pracownia-genetyki",
    component: () => import("/build/pages/pracownia-genetyki/index.vue")
  },
  {
    name: "przygotowanie-do-badania___pl",
    path: "/przygotowanie-do-badania",
    component: () => import("/build/pages/przygotowanie-do-badania.vue")
  },
  {
    name: "testalex-badane-alergeny___pl",
    path: "/testalex/badane-alergeny",
    component: () => import("/build/pages/testalex/badane-alergeny.vue")
  },
  {
    name: "witamina-d-interpretacja___pl",
    path: "/witamina-d/interpretacja",
    component: () => import("/build/pages/witamina-d/interpretacja.vue")
  },
  {
    name: "diagnostyka-alergii___pl",
    path: "/diagnostyka-alergii",
    component: () => import("/build/pages/diagnostyka-alergii/index.vue")
  },
  {
    name: "diagnostyka-autyzmu___pl",
    path: "/diagnostyka-autyzmu",
    component: () => import("/build/pages/diagnostyka-autyzmu/index.vue")
  },
  {
    name: "kiosk-service-break___pl",
    path: "/kiosk/service-break",
    meta: indexBKQlv1YGt1XZpxy01IAMNH6zzSIJnYDiCZULzyKbULwMeta || {},
    component: () => import("/build/pages/kiosk/service-break/index.vue")
  },
  {
    name: "witamina-d-przedawkowanie___pl",
    path: "/witamina-d/przedawkowanie",
    component: () => import("/build/pages/witamina-d/przedawkowanie.vue")
  },
  {
    name: "akcje-profilaktyczne___pl",
    path: "/akcje-profilaktyczne",
    component: () => import("/build/pages/akcje-profilaktyczne/index.vue")
  },
  {
    name: "borelioza-badanie-kleszcza___pl",
    path: "/borelioza/badanie-kleszcza",
    component: () => import("/build/pages/borelioza/badanie-kleszcza.vue")
  },
  {
    name: "kiosk-payment-failed___pl",
    path: "/kiosk/payment/failed",
    meta: indexpFeT0YGPDJZ2lRQCcVpv_456Ivmg8UUv36YnMestGavQoMeta || {},
    component: () => import("/build/pages/kiosk/payment/failed/index.vue")
  },
  {
    name: "nephrohero-zalecenia___pl",
    path: "/nephrohero/zalecenia",
    meta: indexfY7bROlVLF7oSX0R7VY4z8WayAzu36BDkadsIbBDVmgMeta || {},
    component: () => import("/build/pages/nephrohero/zalecenia/index.vue")
  },
  {
    name: "passwordreset-slug___pl",
    path: "/passwordreset/:slug()",
    component: () => import("/build/pages/passwordreset/[slug]/index.vue")
  },
  {
    name: "punkty-pobran-city___pl",
    path: "/punkty-pobran/:city()",
    component: () => import("/build/pages/punkty-pobran/[city]/index.vue")
  },
  {
    name: "akcje-profilaktyczne-slug___pl",
    path: "/akcje-profilaktyczne/:slug()",
    component: () => import("/build/pages/akcje-profilaktyczne/[slug].vue")
  },
  {
    name: "doctor-partner-terms-of-use___pl",
    path: "/doctor/partner-terms-of-use",
    meta: partner_45terms_45of_45use0uWH7pmN0BrJEv41c2JiQtt7hPhRGB7_6jDMayqPfxAMeta || {},
    component: () => import("/build/pages/doctor/partner-terms-of-use.vue")
  },
  {
    name: "interpretacja-wynikow___pl",
    path: "/interpretacja-wynikow",
    component: () => import("/build/pages/interpretacja-wynikow/index.vue")
  },
  {
    name: "katalog-badan-pakiet-wlasny___pl",
    path: "/katalog-badan/pakiet-wlasny",
    component: () => import("/build/pages/katalog-badan/pakiet-wlasny.vue")
  },
  {
    name: "kiosk-payment-success___pl",
    path: "/kiosk/payment/success",
    meta: indexaf_45LteO_45SmAPhyEjyUUono9hWrD_yK9kIMa2TKVep8UMeta || {},
    component: () => import("/build/pages/kiosk/payment/success/index.vue")
  },
  {
    name: "nephrohero-slowniczek___pl",
    path: "/nephrohero/slowniczek",
    meta: indexFTSHSMBb5UVAp_f6QAOhHnjjm6cttXE9PvircT6z98IMeta || {},
    component: () => import("/build/pages/nephrohero/slowniczek/index.vue")
  },
  {
    name: "punkty-pobran-city-slug___pl",
    path: "/punkty-pobran/:city()/:slug()",
    component: () => import("/build/pages/punkty-pobran/[city]/[slug].vue")
  },
  {
    name: "akcje-profilaktyczne-minus50___pl",
    path: "/akcje-profilaktyczne/minus50",
    component: () => import("/build/pages/akcje-profilaktyczne/minus50.vue")
  },
  {
    name: "akcje-profilaktyczne-sexedpl___pl",
    path: "/akcje-profilaktyczne/sexedpl",
    component: () => import("/build/pages/akcje-profilaktyczne/sexedpl.vue")
  },
  {
    name: "diagnostyka-autyzmu-nagalaza___pl",
    path: "/diagnostyka-autyzmu/nagalaza",
    component: () => import("/build/pages/diagnostyka-autyzmu/nagalaza.vue")
  },
  {
    name: "diagnostyka-genetyczna___pl",
    path: "/diagnostyka-genetyczna",
    component: () => import("/build/pages/diagnostyka-genetyczna/index.vue")
  },
  {
    name: "interpretacja-wynikow-odbior___pl",
    path: "/interpretacja-wynikow/odbior",
    component: () => import("/build/pages/interpretacja-wynikow/odbior.vue")
  },
  {
    name: "kiosk-appointment-form___pl",
    path: "/kiosk/appointment-form",
    meta: indexWQWiclLeiD4mkQ_45eUEUSCgPDFn_45hlzDqhIshr_45S_453r0Meta || {},
    component: () => import("/build/pages/kiosk/appointment-form/index.vue")
  },
  {
    name: "kiosk-katalog-badan-wyszukaj___pl",
    path: "/kiosk/katalog-badan/wyszukaj",
    meta: wyszukajAQQ_45chiKu_45i1kRRfMsqzDVcTy6V1KXuU4qt3pDGjxQIMeta || {},
    component: () => import("/build/pages/kiosk/katalog-badan/wyszukaj.vue")
  },
  {
    name: "kiosk-payment-rejected___pl",
    path: "/kiosk/payment/rejected",
    meta: index66DU_45iWf1_javWCLtC_45RGvjZTC0bwy1N2rrFZlfJFWcMeta || {},
    component: () => import("/build/pages/kiosk/payment/rejected/index.vue")
  },
  {
    name: "testalex-jak-i-gdzie-wykonac___pl",
    path: "/testalex/jak-i-gdzie-wykonac",
    component: () => import("/build/pages/testalex/jak-i-gdzie-wykonac.vue")
  },
  {
    name: "akcje-profilaktyczne-100badan___pl",
    path: "/akcje-profilaktyczne/100badan",
    component: () => import("/build/pages/akcje-profilaktyczne/100badan.vue")
  },
  {
    name: "akcje-profilaktyczne-movember___pl",
    path: "/akcje-profilaktyczne/movember",
    component: () => import("/build/pages/akcje-profilaktyczne/movember.vue")
  },
  {
    name: "akcje-profilaktyczne-sezonowa___pl",
    path: "/akcje-profilaktyczne/sezonowa",
    component: () => import("/build/pages/akcje-profilaktyczne/sezonowa.vue")
  },
  {
    name: "borelioza-diagnostyka-wstepna___pl",
    path: "/borelioza/diagnostyka-wstepna",
    component: () => import("/build/pages/borelioza/diagnostyka-wstepna.vue")
  },
  {
    name: "borelioza-testy-potwierdzenia___pl",
    path: "/borelioza/testy-potwierdzenia",
    component: () => import("/build/pages/borelioza/testy-potwierdzenia.vue")
  },
  {
    name: "diagnostyka-nieplodnosci-pary___pl",
    path: "/diagnostyka-nieplodnosci/pary",
    component: () => import("/build/pages/diagnostyka-nieplodnosci/pary.vue")
  },
  {
    name: "akcje-profilaktyczne-blackweek___pl",
    path: "/akcje-profilaktyczne/blackweek",
    component: () => import("/build/pages/akcje-profilaktyczne/blackweek.vue")
  },
  {
    name: "akcje-profilaktyczne-kwartalna___pl",
    path: "/akcje-profilaktyczne/kwartalna",
    component: () => import("/build/pages/akcje-profilaktyczne/kwartalna.vue")
  },
  {
    name: "badania-mikrobiologiczne___pl",
    path: "/badania-mikrobiologiczne",
    component: () => import("/build/pages/badania-mikrobiologiczne/index.vue")
  },
  {
    name: "contact-informacje-o-badaniach___pl",
    path: "/contact/informacje-o-badaniach",
    component: () => import("/build/pages/contact/informacje-o-badaniach.vue")
  },
  {
    name: "diagnostyka-autyzmu-genetyczna___pl",
    path: "/diagnostyka-autyzmu/genetyczna",
    component: () => import("/build/pages/diagnostyka-autyzmu/genetyczna.vue")
  },
  {
    name: "diagnostyka-autyzmu-podstawowe___pl",
    path: "/diagnostyka-autyzmu/podstawowe",
    component: () => import("/build/pages/diagnostyka-autyzmu/podstawowe.vue")
  },
  {
    name: "diagnostyka-nieplodnosci___pl",
    path: "/diagnostyka-nieplodnosci",
    component: () => import("/build/pages/diagnostyka-nieplodnosci/index.vue")
  },
  {
    name: "diagnostyka-nieplodnosci-kobiet___pl",
    path: "/diagnostyka-nieplodnosci/kobiet",
    component: () => import("/build/pages/diagnostyka-nieplodnosci/kobiet.vue")
  },
  {
    name: "diagnostyka-autyzmu-biochemiczna___pl",
    path: "/diagnostyka-autyzmu/biochemiczna",
    component: () => import("/build/pages/diagnostyka-autyzmu/biochemiczna.vue")
  },
  {
    name: "diagnostyka-autyzmu-endotoksemia___pl",
    path: "/diagnostyka-autyzmu/endotoksemia",
    component: () => import("/build/pages/diagnostyka-autyzmu/endotoksemia.vue")
  },
  {
    name: "testalex-przykladowe-konsultacje___pl",
    path: "/testalex/przykladowe-konsultacje",
    component: () => import("/build/pages/testalex/przykladowe-konsultacje.vue")
  },
  {
    name: "akcje-profilaktyczne-minus-koszyk___pl",
    path: "/akcje-profilaktyczne/minus-koszyk",
    component: () => import("/build/pages/akcje-profilaktyczne/minus-koszyk.vue")
  },
  {
    name: "badania-mikrobiologiczne-gruzlica___pl",
    path: "/badania-mikrobiologiczne/gruzlica",
    component: () => import("/build/pages/badania-mikrobiologiczne/gruzlica.vue")
  },
  {
    name: "diagnostyka-nieplodnosci-mezczyzn___pl",
    path: "/diagnostyka-nieplodnosci/mezczyzn",
    component: () => import("/build/pages/diagnostyka-nieplodnosci/mezczyzn.vue")
  },
  {
    name: "kiosk-payment-no-connection___pl",
    path: "/kiosk/payment/no-connection",
    meta: indexx5Pq_Gd8NdFbKVEQLTbZgsMLHLRd2XFg5NkwYlUlCMsMeta || {},
    component: () => import("/build/pages/kiosk/payment/no-connection/index.vue")
  },
  {
    name: "pojedyncze-testy-alergenowe___pl",
    path: "/pojedyncze-testy-alergenowe",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/index.vue")
  },
  {
    name: "akcje-profilaktyczne-punkty-pobran___pl",
    path: "/akcje-profilaktyczne/punkty-pobran",
    component: () => import("/build/pages/akcje-profilaktyczne/punkty-pobran.vue")
  },
  {
    name: "akcje-profilaktyczne-suplementacja___pl",
    path: "/akcje-profilaktyczne/suplementacja",
    component: () => import("/build/pages/akcje-profilaktyczne/suplementacja.vue")
  },
  {
    name: "borelioza-uzupelnienie-diagnostyki___pl",
    path: "/borelioza/uzupelnienie-diagnostyki",
    component: () => import("/build/pages/borelioza/uzupelnienie-diagnostyki.vue")
  },
  {
    name: "diagnostyka-alergii-panele-atopowe___pl",
    path: "/diagnostyka-alergii/panele-atopowe",
    component: () => import("/build/pages/diagnostyka-alergii/panele-atopowe.vue")
  },
  {
    name: "diagnostyka-alergii-panele-wziewne___pl",
    path: "/diagnostyka-alergii/panele-wziewne",
    component: () => import("/build/pages/diagnostyka-alergii/panele-wziewne.vue")
  },
  {
    name: "diagnostyka-autyzmu-markery-stresu___pl",
    path: "/diagnostyka-autyzmu/markery-stresu",
    component: () => import("/build/pages/diagnostyka-autyzmu/markery-stresu.vue")
  },
  {
    name: "interpretacja-wynikow-slug-step___pl",
    path: "/interpretacja-wynikow/:slug()/:step()",
    component: () => import("/build/pages/interpretacja-wynikow/[slug]/[step].vue")
  },
  {
    name: "akcje-profilaktyczne-miesiac-rodziny___pl",
    path: "/akcje-profilaktyczne/miesiac-rodziny",
    component: () => import("/build/pages/akcje-profilaktyczne/miesiac-rodziny.vue")
  },
  {
    name: "diagnostyka-alergii-panele-pokarmowe___pl",
    path: "/diagnostyka-alergii/panele-pokarmowe",
    component: () => import("/build/pages/diagnostyka-alergii/panele-pokarmowe.vue")
  },
  {
    name: "kiosk-appointment-confirmation___pl",
    path: "/kiosk/appointment-confirmation",
    meta: indexEanhnN2qJW2Se9VxpYCG9yY8Qe_45WHkbrbrY9uykx4yAMeta || {},
    component: () => import("/build/pages/kiosk/appointment-confirmation/index.vue")
  },
  {
    name: "diagnostyka-alergii-panel-molekularny___pl",
    path: "/diagnostyka-alergii/panel-molekularny",
    component: () => import("/build/pages/diagnostyka-alergii/panel-molekularny.vue")
  },
  {
    name: "pojedyncze-testy-alergenowe-testy-mix___pl",
    path: "/pojedyncze-testy-alergenowe/testy-mix",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/testy-mix.vue")
  },
  {
    name: "pracownia-genetyki-genetyka-czlowieka___pl",
    path: "/pracownia-genetyki/genetyka-czlowieka",
    component: () => import("/build/pages/pracownia-genetyki/genetyka-czlowieka.vue")
  },
  {
    name: "diagnostyka-alergii-panele-molekularne___pl",
    path: "/diagnostyka-alergii/panele-molekularne",
    component: () => import("/build/pages/diagnostyka-alergii/panele-molekularne.vue")
  },
  {
    name: "pracownia-genetyki-poradnia-genetyczna___pl",
    path: "/pracownia-genetyki/poradnia-genetyczna",
    component: () => import("/build/pages/pracownia-genetyki/poradnia-genetyczna.vue")
  },
  {
    name: "akcje-profilaktyczne-nowe-pakiety-badan___pl",
    path: "/akcje-profilaktyczne/nowe-pakiety-badan",
    component: () => import("/build/pages/akcje-profilaktyczne/nowe-pakiety-badan.vue")
  },
  {
    name: "akcje-profilaktyczne-rozowa-wstazka-data___pl",
    path: "/akcje-profilaktyczne/rozowa-wstazka/data",
    component: () => import("/build/pages/akcje-profilaktyczne/rozowa-wstazka/data.js")
  },
  {
    name: "diagnostyka-alergii-panele-pediatryczne___pl",
    path: "/diagnostyka-alergii/panele-pediatryczne",
    component: () => import("/build/pages/diagnostyka-alergii/panele-pediatryczne.vue")
  },
  {
    name: "diagnostyka-autyzmu-zaburzen-jelitowych___pl",
    path: "/diagnostyka-autyzmu/zaburzen-jelitowych",
    component: () => import("/build/pages/diagnostyka-autyzmu/zaburzen-jelitowych.vue")
  },
  {
    name: "katalog-badan-badania-category_slug___pl",
    path: "/katalog-badan/badania/:category_slug?",
    component: () => import("/build/pages/katalog-badan/badania/[[category_slug]].vue")
  },
  {
    name: "katalog-badan-pakiety-category_slug___pl",
    path: "/katalog-badan/pakiety/:category_slug?",
    component: () => import("/build/pages/katalog-badan/pakiety/[[category_slug]].vue")
  },
  {
    name: "akcje-profilaktyczne-rozowa-wstazka-brca1___pl",
    path: "/akcje-profilaktyczne/rozowa-wstazka/brca1",
    component: () => import("/build/pages/akcje-profilaktyczne/rozowa-wstazka/brca1.vue")
  },
  {
    name: "akcje-profilaktyczne-rozowa-wstazka-brca2___pl",
    path: "/akcje-profilaktyczne/rozowa-wstazka/brca2",
    component: () => import("/build/pages/akcje-profilaktyczne/rozowa-wstazka/brca2.vue")
  },
  {
    name: "akcje-profilaktyczne-rozowa-wstazka___pl",
    path: "/akcje-profilaktyczne/rozowa-wstazka",
    component: () => import("/build/pages/akcje-profilaktyczne/rozowa-wstazka/index.vue")
  },
  {
    name: "badania-mikrobiologiczne-biocenoza-pochwy___pl",
    path: "/badania-mikrobiologiczne/biocenoza-pochwy",
    component: () => import("/build/pages/badania-mikrobiologiczne/biocenoza-pochwy.vue")
  },
  {
    name: "diagnostyka-genetyczna-components-methods___pl",
    path: "/diagnostyka-genetyczna/components/methods",
    component: () => import("/build/pages/diagnostyka-genetyczna/components/methods.vue")
  },
  {
    name: "akcje-profilaktyczne-dzien-babci-i-dziadka___pl",
    path: "/akcje-profilaktyczne/dzien-babci-i-dziadka",
    component: () => import("/build/pages/akcje-profilaktyczne/dzien-babci-i-dziadka.vue")
  },
  {
    name: "akcje-profilaktyczne-po-drodze-ze-zdrowiem___pl",
    path: "/akcje-profilaktyczne/po-drodze-ze-zdrowiem",
    component: () => import("/build/pages/akcje-profilaktyczne/po-drodze-ze-zdrowiem.vue")
  },
  {
    name: "pojedyncze-testy-alergenowe-jady-leki-inne___pl",
    path: "/pojedyncze-testy-alergenowe/jady-leki-inne",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/jady-leki-inne.vue")
  },
  {
    name: "badania-mikrobiologiczne-zakazenia-pokarmowe___pl",
    path: "/badania-mikrobiologiczne/zakazenia-pokarmowe",
    component: () => import("/build/pages/badania-mikrobiologiczne/zakazenia-pokarmowe.vue")
  },
  {
    name: "diagnostyka-autyzmu-aktywnosc-immunologiczna___pl",
    path: "/diagnostyka-autyzmu/aktywnosc-immunologiczna",
    component: () => import("/build/pages/diagnostyka-autyzmu/aktywnosc-immunologiczna.vue")
  },
  {
    name: "diagnostyka-autyzmu-mikroelementy-i-witaminy___pl",
    path: "/diagnostyka-autyzmu/mikroelementy-i-witaminy",
    component: () => import("/build/pages/diagnostyka-autyzmu/mikroelementy-i-witaminy.vue")
  },
  {
    name: "pojedyncze-testy-alergenowe-alergeny-wziewne___pl",
    path: "/pojedyncze-testy-alergenowe/alergeny-wziewne",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/alergeny-wziewne.vue")
  },
  {
    name: "akcje-profilaktyczne-rozowa-wstazka-cytologia___pl",
    path: "/akcje-profilaktyczne/rozowa-wstazka/cytologia",
    component: () => import("/build/pages/akcje-profilaktyczne/rozowa-wstazka/cytologia.vue")
  },
  {
    name: "kiosk-katalog-badan-badania-category_slug___pl",
    path: "/kiosk/katalog-badan/badania/:category_slug?",
    meta: _91_91category_slug_93_93PfDh3CPfq2PWfRotpqHGj1daVBX4KkFGDf0dOp0nkXAMeta || {},
    component: () => import("/build/pages/kiosk/katalog-badan/badania/[[category_slug]].vue")
  },
  {
    name: "kiosk-katalog-badan-pakiety-category_slug___pl",
    path: "/kiosk/katalog-badan/pakiety/:category_slug?",
    meta: _91_91category_slug_93_933OhST4Ulnkq_450MS_45wr1st_JFbjT_45gfLaSXhxs8fvpIkMeta || {},
    component: () => import("/build/pages/kiosk/katalog-badan/pakiety/[[category_slug]].vue")
  },
  {
    name: "pojedyncze-testy-alergenowe-pakiety-alergenow___pl",
    path: "/pojedyncze-testy-alergenowe/pakiety-alergenow",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/pakiety-alergenow.vue")
  },
  {
    name: "diagnostyka-genetyczna-components-consultation___pl",
    path: "/diagnostyka-genetyczna/components/consultation",
    component: () => import("/build/pages/diagnostyka-genetyczna/components/consultation.vue")
  },
  {
    name: "nephrohero-przewlekla-choroba-nerek-pchn___pl",
    path: "/nephrohero/przewlekla-choroba-nerek-pchn",
    meta: indexJyn4oEFNN3S1XBJqvETyNYPthBT0Q05uEWlbCebZLrgMeta || {},
    component: () => import("/build/pages/nephrohero/przewlekla-choroba-nerek-pchn/index.vue")
  },
  {
    name: "pojedyncze-testy-alergenowe-alergeny-pokarmowe___pl",
    path: "/pojedyncze-testy-alergenowe/alergeny-pokarmowe",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/alergeny-pokarmowe.vue")
  },
  {
    name: "nephrohero-diagnostyka-laboratoryjna-pchn___pl",
    path: "/nephrohero/diagnostyka-laboratoryjna-pchn",
    meta: index1tQFpEXpFJOJgjdu6XHAnBToLAjSC_45wEz1cnCPq3F2MMeta || {},
    component: () => import("/build/pages/nephrohero/diagnostyka-laboratoryjna-pchn/index.vue")
  },
  {
    name: "pojedyncze-testy-alergenowe-molekuly-alergenowe___pl",
    path: "/pojedyncze-testy-alergenowe/molekuly-alergenowe",
    component: () => import("/build/pages/pojedyncze-testy-alergenowe/molekuly-alergenowe.vue")
  },
  {
    name: "diagnostyka-genetyczna-ojcostwo-testy-pokrewienstwa___pl",
    path: "/diagnostyka-genetyczna/ojcostwo-testy-pokrewienstwa",
    component: () => import("/build/pages/diagnostyka-genetyczna/ojcostwo-testy-pokrewienstwa.vue")
  },
  {
    name: "diagnostyka-genetyczna-onkologia-testy-predyspozycji___pl",
    path: "/diagnostyka-genetyczna/onkologia-testy-predyspozycji",
    component: () => import("/build/pages/diagnostyka-genetyczna/onkologia-testy-predyspozycji.vue")
  },
  {
    name: "diagnostyka-genetyczna-zaburzenia-gospodarki-lipidowej___pl",
    path: "/diagnostyka-genetyczna/zaburzenia-gospodarki-lipidowej",
    component: () => import("/build/pages/diagnostyka-genetyczna/zaburzenia-gospodarki-lipidowej.vue")
  },
  {
    name: "pracownia-genetyki-nieinwazyjna-diagnostyka-prenatalna___pl",
    path: "/pracownia-genetyki/nieinwazyjna-diagnostyka-prenatalna",
    component: () => import("/build/pages/pracownia-genetyki/nieinwazyjna-diagnostyka-prenatalna.vue")
  },
  {
    name: "diagnostyka-genetyczna-farmakogenetyka-opornosc-na-leki___pl",
    path: "/diagnostyka-genetyczna/farmakogenetyka-opornosc-na-leki",
    component: () => import("/build/pages/diagnostyka-genetyczna/farmakogenetyka-opornosc-na-leki.vue")
  },
  {
    name: "badania-mikrobiologiczne-badania-w-kierunku-dermatofitow___pl",
    path: "/badania-mikrobiologiczne/badania-w-kierunku-dermatofitow",
    component: () => import("/build/pages/badania-mikrobiologiczne/badania-w-kierunku-dermatofitow.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-pediatrii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-pediatrii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-pediatrii.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-nefrologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-nefrologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-nefrologii.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-neurologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-neurologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-neurologii.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-kardiologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-kardiologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-kardiologii.vue")
  },
  {
    name: "pracownia-genetyki-identyfikacja-genetyczna-mikroorganizmow___pl",
    path: "/pracownia-genetyki/identyfikacja-genetyczna-mikroorganizmow",
    component: () => import("/build/pages/pracownia-genetyki/identyfikacja-genetyczna-mikroorganizmow.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-dermatologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-dermatologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-dermatologii.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-pulmonologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-pulmonologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-pulmonologii.vue")
  },
  {
    name: "diagnostyka-genetyczna-onkologia-diagnostyka-terapia-celowana___pl",
    path: "/diagnostyka-genetyczna/onkologia-diagnostyka-terapia-celowana",
    component: () => import("/build/pages/diagnostyka-genetyczna/onkologia-diagnostyka-terapia-celowana.vue")
  },
  {
    name: "badania-mikrobiologiczne-badanie-w-kierunku-nuzycy-dermodekozy___pl",
    path: "/badania-mikrobiologiczne/badanie-w-kierunku-nuzycy-dermodekozy",
    component: () => import("/build/pages/badania-mikrobiologiczne/badanie-w-kierunku-nuzycy-dermodekozy.vue")
  },
  {
    name: "badania-mikrobiologiczne-identyfikacja-drobnoustrojow-maldi-tof-ms___pl",
    path: "/badania-mikrobiologiczne/identyfikacja-drobnoustrojow-maldi-tof-ms",
    component: () => import("/build/pages/badania-mikrobiologiczne/identyfikacja-drobnoustrojow-maldi-tof-ms.vue")
  },
  {
    name: "diagnostyka-genetyczna-badania-panelowe-badanie-wes-choroby-rzadkie___pl",
    path: "/diagnostyka-genetyczna/badania-panelowe-badanie-wes-choroby-rzadkie",
    component: () => import("/build/pages/diagnostyka-genetyczna/badania-panelowe-badanie-wes-choroby-rzadkie.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-zespolow-dysmorficznych___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-zespolow-dysmorficznych",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-zespolow-dysmorficznych.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-immunologii-i-hematologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-immunologii-i-hematologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-immunologii-i-hematologii.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-okulistyce-i-otolaryngologii___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-okulistyce-i-otolaryngologii",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-okulistyce-i-otolaryngologii.vue")
  },
  {
    name: "diagnostyka-genetyczna-zaburzenia-gospodarki-weglowodanowej-genetyka-cukrzycy___pl",
    path: "/diagnostyka-genetyczna/zaburzenia-gospodarki-weglowodanowej-genetyka-cukrzycy",
    component: () => import("/build/pages/diagnostyka-genetyczna/zaburzenia-gospodarki-weglowodanowej-genetyka-cukrzycy.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-nieplodnosci-planowanie-ciazy-badania-prenatalne___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-nieplodnosci-planowanie-ciazy-badania-prenatalne",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-nieplodnosci-planowanie-ciazy-badania-prenatalne.vue")
  },
  {
    name: "diagnostyka-genetyczna-diagnostyka-genetyczna-w-gastroenterologii-endokrynologii-i-chorobach-metabolicznych___pl",
    path: "/diagnostyka-genetyczna/diagnostyka-genetyczna-w-gastroenterologii-endokrynologii-i-chorobach-metabolicznych",
    component: () => import("/build/pages/diagnostyka-genetyczna/diagnostyka-genetyczna-w-gastroenterologii-endokrynologii-i-chorobach-metabolicznych.vue")
  }
]